<template>
    <div class="mt-3">
        <div class="flex justify-between items-center bg-indigo-600 rounded-lg py-3 cursor-pointer px-3" @click="openTaxeFonciere = !openTaxeFonciere">
            <h2 class="text-white text-lg">Taxe foncières</h2>
            <span class="text-sm text-white">
                <font-awesome-icon v-if="openTaxeFonciere" :icon="['fa', 'chevron-down']" />
                <font-awesome-icon v-else :icon="['fa', 'chevron-right']" />
            </span>
        </div>

        <div class="overflow-x-auto overflow-y-visible" v-if="openTaxeFonciere">
            <PaginationBlock v-if="paginator && paginator.total > 0" :paginator="paginator" @changePage="changePage"/>
            <table class="w-full border-t-2 border-gray-600">
                <thead>
                    <tr class="">
                        <th scope="col" class="text-left py-2 px-2 text-sm font-normal rtl:text-right text-gray-500 dark:text-gray-400">
                            Année
                        </th>
                        <th scope="col" class="text-left py-2 px-2 text-sm font-normal rtl:text-right text-gray-500 dark:text-gray-400">
                            Montant
                        </th>
                        <th scope="col" class="text-left py-3 px-2 text-sm font-normal rtl:text-right text-gray-500 dark:text-gray-400">
                            Date de paiement
                        </th>
                        <th scope="col" class="text-left py-3.5 px-2 flex justify-end items-center">
                            <button class="btn btn-primary" @click="addNewTaxeFonciere = true">
                                <font-awesome-icon class="text-md" :icon="['fa', 'plus']" />
                            </button>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr 
                        v-if="addNewTaxeFonciere"
                        class="border-t border-indigo-300"
                    >
                        <td class="px-2 py-3 text-sm font-medium whitespace-nowrap text-gray-700 dark:text-gray-300">
                            <AppInput 
                                v-model='form.year' 
                                id='year'
                                :validations="['year', 'required']"
                                @hasError="handleFormError"
                                :check-on-create="false"
                                :check-on-unfocus="true"
                            />
                        </td>
                        <td class="px-2 py-3 text-sm font-medium whitespace-nowrap text-gray-700 dark:text-gray-300">
                            <AppInput 
                                v-model='form.amount'
                                id='amount'
                                :validations="['number', 'required']"
                                @hasError="handleFormError"
                                :check-on-create="false"
                                :check-on-unfocus="true"
                                icon="euro-sign"
                            />
                        </td>
                        <td class="px-2 py-3 text-sm font-medium text-gray-700 dark:text-gray-300">
                            <DatePicker 
                                v-model='form.paiementDate' 
                                class="mt-3 mr-2"
                                id='paiementDate' 
                            />
                        </td>
                        <td class="px-2 py-3 text-sm whitespace-nowrap">
                            <div class="flex justify-end items-center">
                                <button class="btn-secondary mr-1" @click="addNewTaxeFonciere = false">
                                    <font-awesome-icon class="text-sm" :icon="['fa', 'undo']" />
                                </button>
                                <button class="btn-success" :class="checkFieldValid ? '' : 'cursor-not-allowed bg-emerald-300 border-emerald-300 hover:bg-emerald-300 hover:border-emerald-300'" @click="addTaxeFonciere()">
                                    <font-awesome-icon v-if="addLoader" class="text-sm animate-spin" :icon="['fas', 'spinner']"  />
                                    <font-awesome-icon v-else class="text-sm" :icon="['fa', 'check']" />
                                </button>
                            </div>
                        </td>
                    </tr>
                    <template
                        v-if="paginator && paginator.results && paginator.results.length !== 0"
                    >
                        <template
                            v-for="taxeFonciere of paginator.results" :key="taxeFonciere.uuid"
                        >
                            <TaxeFonciereItem :taxeFonciere="taxeFonciere" @refresh="loadTaxeFonciere" />
                        </template>

                    </template>
                    <tr
                        class="px-2 py-3 border-t border-gray-200 dark:border-gray-800"
                        v-else-if="!loaded"
                    >
                        <td colspan="5">
                            <SpinnerLoader class="mt-5"></SpinnerLoader>
                        </td>
                    </tr>
                    <tr
                        class="px-2 py-3 border-t border-gray-200 dark:border-gray-800"
                        v-else-if="!addNewTaxeFonciere"
                    >
                        <td colspan="5" class="text-center">
                            <p class="text-sm text-indigo-400 my-4">Aucune taxe foncière n'a été trouvé.</p>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>

import SpinnerLoader from './../../../loader/SpinnerLoader';
import PaginationBlock from './../../../composant/PaginationBlock';
import AppInput from './../../../form/AppInput';
import DatePicker from './../../../form/DatePicker';
import TaxeFonciereItem from './../../../bien/details/financials/TaxeFonciereItem';
export default {
    components: {
        SpinnerLoader,
        PaginationBlock,
        AppInput,
        DatePicker,
        TaxeFonciereItem
    },

    data() {
        return {
            paginator: {
                results: []
            },
            loaded: false,
            addNewTaxeFonciere: false,
            addLoader: false,
            form: {
                year: new Date().getFullYear(),
                amount: null,
                paiementDate: null
            },
            formInvalid: [],
            openTaxeFonciere: false,
        }
    },

    created() {
        this.loadTaxeFonciere()
    },

    computed: {
        checkFieldValid() {
            return this.formInvalid.length === 0 && this.form.year.length !== 0 && this.form.amount;
        }
    },

    methods: {
        async changePage(page) {
            await this.loadTaxeFonciere(page)
        },

        async loadTaxeFonciere(page = 1) {
            this.loaded = false
            this.paginator.results = []

            this.paginator = await this.$api.bien.getTaxeFoncieres(page, this.$route.params.bienUuid);

            this.loaded = true
        },

        handleFormError(event) {
            if (event.value && !this.formInvalid.includes(event.name)) {
                this.formInvalid.push(event.name);
            }

            if (!event.value && this.formInvalid.includes(event.name)) {
                this.formInvalid = this.formInvalid.filter(f => f !== event.name)
            }
        },

        async addTaxeFonciere() {
            if (!this.checkFieldValid) {
                return;
            }

            this.addLoader = true

            await this.$api.bien.addTaxeFonciere(this.$route.params.bienUuid, {
                year: this.form.year && this.form.year.toString(),
                amount: this.form.amount,
                paiement_date: this.form.paiementDate
            })
            .then(async () => {
                this.$toast({title: 'Succès', description: "La taxe foncière à bien été enregistré."}, this.$toastSuccess);
                this.form = {
                    year: new Date().getFullYear(),
                    amount: null,
                    paiementDate: null
                }
                await this.loadTaxeFonciere()
            })
            .catch((err) => {
                console.log(err);
                this.$toast({title: 'Erreur', description: "Une erreur est survenue, veuillez réessayer plus tard."}, this.$toastError);
            })

            this.addNewTaxeFonciere = false
            this.addLoader = false
        },
    }
};
</script>
